import { useSelector } from '@xstate/react'

import { AppActorContext } from '@/components/AppActorProvider/AppActorProvider'
import { AppContext } from '@/state/AppStateMachine'
import { GameState, RunnerContext, RunnerSnapshot } from '@/state/RunnerStateMachine'
import { pick } from '@/utils/object.utils'

export function useRunnerState() {
  const actor = AppActorContext.useSelector((state) => (state.context as AppContext).runner)

  const context = useSelector(actor, (state) => state.context as RunnerContext)
  const persona = context.persona || 'pedro'
  const scenario = context.scenario || 0

  const isIdle = useSelector(actor, (state) => state.matches('idle'))
  const isLoading = useSelector(actor, (state) => state.matches('loading'))
  const isRunning = useSelector(actor, (state) => state.matches('running'))
  const isPopin = useSelector(actor, (state) => state.matches('popin'))

  const gameState = useSelector(actor, (snapshot: RunnerSnapshot) => snapshot.context.game)
  const shoppingState = useSelector(actor, (snapshot: RunnerSnapshot) => snapshot.context.shopping)

  return {
    actor,
    context,
    persona,
    scenario,

    isIdle,
    isLoading,
    isRunning,
    isPopin,

    gameState,
    shoppingState,
  }
}

export function useGameState(): GameState
export function useGameState<T extends Array<keyof GameState>>(keys?: T): Pick<GameState, T[number]>
export function useGameState<T extends Array<keyof GameState>>(keys?: T) {
  const { actor } = useRunnerState()
  const gameContext = useSelector(actor, (state) => {
    const ctx = state.context.game
    return keys ? pick(ctx, keys) : ctx
  })

  return gameContext
}
